class StoreLocator {
    constructor() {
        this.stockistWidget = null;
        this.continueButton = null;
        this.dealerCountDisplay = null;

        this.init();
    }

    init() {
        this.stockistWidget = document.querySelector('stockist-store-locator');
        this.continueButton = document.getElementById('continue-to-quote');
        this.dealerCountDisplay = document.getElementById('dealer-count');
        
        if (!this.stockistWidget || !this.continueButton || !this.dealerCountDisplay) {
            return;
        }

        this.setupMaxSelections();
        this.loadPreselectedDealers();
        this.loadPreselectedFilters();
        this.setupStockistCallback();
        this.attachEventListeners();
    }

    loadPreselectedDealers() {
        const savedDealers = CoeckUtils.loadSelectedDealers();

        this.updateContinueButton(savedDealers);
        this.updateDealerCount(savedDealers);
        
        if (savedDealers.length > 0) {
            const dealerIds = savedDealers
                .filter(dealer => dealer.id)
                .map(dealer => dealer.id);
            
            if (dealerIds.length > 0) {
                window.stockistPreselectedLocations = dealerIds;
            }
        }
    }

    setupMaxSelections() {
        window.stockistMaxSelections = 3;
    }

    loadPreselectedFilters() {
        const collectionIds = document.getElementById('dealers-quote-wrapper').dataset.collectionFilterIds.split(',');

        if (0 === collectionIds.length) {
            return;
        }

        window.stockistPreselectedFilters = collectionIds;
    }

    setupStockistCallback() {        
        const setCallback = () => {
            window.onStockistSelectionChanged = (selectedStores) => {
                this.saveSelectedDealers(selectedStores);
                this.updateContinueButton(selectedStores);
                this.updateDealerCount(selectedStores);

                if (selectedStores.length >= window.stockistMaxSelections) {
                    this.stockistWidget.classList.add('max-selection-reached');

                    return;
                }
                    
                this.stockistWidget.classList.remove('max-selection-reached');
            };
        };

        setCallback();
        
        const checkExternalScriptLoaded = setInterval(() => {
            if (typeof window._stockistConfigCallback_map_p3x4mw63 !== 'undefined') {
                clearInterval(checkExternalScriptLoaded);

                setTimeout(setCallback, 100);
            }
        }, 100);
    }

    attachEventListeners() {
        if (this.continueButton) {
            this.continueButton.addEventListener('click', this.handleContinueClick.bind(this));
        }
    }

    handleContinueClick(event) {
        const selectedDealers = CoeckUtils.loadSelectedDealers();
        if (selectedDealers.length === 0) {
            return;
        }

        window.location.href = event.target.dataset.nextPage;
    }

    saveSelectedDealers(selectedStores) {
        const dealers = selectedStores.map(store => ({
            id: store.id || '',
            name: store.name || '',
            email: store.email || '',
            address: store.address || '',
            custom: store.custom || {},
        }));
        
        CoeckUtils.saveSelectedDealers(dealers);
    }

    updateContinueButton(selectedStores) {
        this.continueButton.disabled = selectedStores.length === 0;
    }

    updateDealerCount(selectedStores) {        
        if (!this.dealerCountDisplay) {
            return;
        }

        const count = selectedStores.length;
        const translationDealersSelected = this.dealerCountDisplay.dataset.translationDealersSelected;
        const translationNoDealers = this.dealerCountDisplay.dataset.translationNoDealers;

        this.dealerCountDisplay.textContent = count > 0 ? `${count} ${translationDealersSelected}` : translationNoDealers;
        this.dealerCountDisplay.style.display = 'inline';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.StoreLocator = new StoreLocator();
});